import IAddress from '@sunbit-dev/common/models/IAddress';

export const getGoogleAddress = (place: google.maps.places.PlaceResult): IAddress => {
  let address: IAddress = {
    address: '',
    city: '',
    state: '',
    zipcode: '',
  };
  if (place.address_components) {
    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      const componentType = component.types[0];

      switch (componentType) {
        case 'street_number': {
          address.address = `${component.long_name} ${address.address}`;
          break;
        }
        case 'route': {
          address.address += component.short_name;
          break;
        }
        case 'postal_code': {
          const zip = `${component.long_name}${address.zipcode || ''}`;
          address.zipcode = zip || '';
          break;
        }
        case 'postal_code_suffix': {
          address.zipcode = `${address.zipcode || ''}${component.long_name}`;
          break;
        }
        case 'locality':
          address.city = component.long_name;
          break;
        case 'administrative_area_level_1': {
          address.state = component.short_name;
          break;
        }

        case 'country':
          break;
      }
    }
  }
  return address;
};
